"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("h1", [_vm._v("Apuração e cálculo")]), _vm._v(" "), _c("div", {
    staticClass: "header-bar"
  }, [_c("b-field", {
    attrs: {
      label: "Filtrar por pontos:"
    }
  }, [_c("b-select", {
    attrs: {
      expanded: ""
    },
    on: {
      input: _vm.onFilterChange
    },
    model: {
      value: _vm.filters.period,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "period", $$v);
      },
      expression: "filters.period"
    }
  }, [_c("option", {
    attrs: {
      value: "all"
    }
  }, [_vm._v("\n            Todos\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "week"
    }
  }, [_vm._v("\n            Semanais\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "month"
    }
  }, [_vm._v("\n            Mensais\n          ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "year"
    }
  }, [_vm._v("\n            Anuais\n          ")])])], 1)], 1), _vm._v(" "), _c("AttendanceReportsTable", {
    attrs: {
      data: _vm.data,
      "is-loading": _vm.isLoading
    },
    on: {
      "create-absence": _vm.handleCreateAbsence,
      "summary-attendances-month": _vm.handleSummaryAttendancesMonth
    }
  }), _vm._v(" "), _c("b-pagination", {
    staticClass: "mt-4",
    attrs: {
      total: _vm.meta.total,
      current: _vm.meta.currentPage,
      "per-page": _vm.meta.perPage,
      "range-before": "2",
      "range-after": "2",
      size: "is-small",
      order: "is-centered"
    },
    on: {
      "update:current": function updateCurrent($event) {
        return _vm.$set(_vm.meta, "currentPage", $event);
      },
      change: _vm.handlePageChange
    }
  }), _vm._v(" "), _c("CreateAbsenceModal", {
    attrs: {
      "is-modal-active": _vm.isModalActive,
      "user-id": _vm.selectedTimesheet.userId,
      date: _vm.selectedTimesheet.date
    },
    on: {
      onCreate: _vm.fetchTimesheetsReports,
      onClose: function onClose($event) {
        _vm.isModalActive = false;
      }
    }
  }), _vm._v(" "), _c("ExportSummaryAttendancesMonth", {
    ref: "exporter"
  })], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;